(function () {
  'use strict';

  function initPurchaseMobile(root) {
    if (!root || root.dataset.purchaseMobileReady === 'true') return;
    root.dataset.purchaseMobileReady = 'true';

    const decreaseButton = root.querySelector('[data-quantity-decrease]');
    const increaseButton = root.querySelector('[data-quantity-increase]');
    const quantityOutput = root.querySelector('[data-quantity-value]');
    const ctaButton = root.querySelector('[data-cart-add]');
    const ctaText = root.querySelector('[data-purchase-cta-text]');
    const errorNode = root.querySelector('[data-purchase-mobile-error]');

    const hasProduct = root.getAttribute('data-has-product') === 'true';
    const available = root.getAttribute('data-available') === 'true';
    const soldOutLabel = root.getAttribute('data-sold-out-label') || 'Немає в наявності';
    const defaultCtaLabel = root.getAttribute('data-default-cta-label') || 'Додати у кошик';

    let quantity = 1;

    function showError(message) {
      if (!errorNode) return;
      errorNode.textContent = message || '';
      errorNode.hidden = !message;
    }

    function renderQuantity() {
      if (!quantityOutput) return;
      quantityOutput.textContent = String(quantity);
      if (ctaButton) {
        ctaButton.setAttribute('data-quantity', String(quantity));
      }
    }

    function renderAvailability() {
      if (!ctaButton || !ctaText) return;
      if (ctaButton.classList.contains('is-cart-loading')) return;

      if (!hasProduct || !available) {
        ctaButton.disabled = true;
        ctaText.textContent = hasProduct && !available ? soldOutLabel : defaultCtaLabel;
        return;
      }

      ctaButton.disabled = false;
      ctaText.textContent = defaultCtaLabel;
    }

    decreaseButton?.addEventListener('click', function () {
      if (quantity <= 1) return;
      quantity -= 1;
      renderQuantity();
      showError('');
    });

    increaseButton?.addEventListener('click', function () {
      quantity += 1;
      renderQuantity();
      showError('');
    });

    document.addEventListener('cart:updated', function () {
      showError('');
      renderAvailability();
    });

    renderQuantity();
    renderAvailability();
  }

  function initAll(scope) {
    const context = scope || document;
    context.querySelectorAll('[data-purchase-mobile]').forEach(initPurchaseMobile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!(event.target instanceof Element)) return;
    initAll(event.target);
  });
})();
